import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment";

class RelativeDuration extends React.Component {
    static propTypes = {
        date: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.timer = null;
        this.updateTime = this.updateTime.bind(this);
    }

    componentWillMount() {
        this.updateTime();
        this.timer = setInterval(this.updateTime, 1000);
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    updateTime() {
        this.setState({
            now: moment(),
        });
    }

    render() {
        const {date} = this.props;
        const {now} = this.state;
        const duration = now.diff(date, 'seconds');

        return (
            <span>
                {Math.floor(duration / 60) + ':' + ('' + duration % 60).padStart(2, '0')}
            </span>
        )
    }
}

export default RelativeDuration;


// WEBPACK FOOTER //
// ./src/components/RelativeDuration.jsx